var React = require('react');

function UploadInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4","key":0}),React.createElement("polyline",{"points":"17 8 12 3 7 8","key":1}),React.createElement("line",{"x1":"12","y1":"3","x2":"12","y2":"15","key":2})]);
}

UploadInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"#CE1635","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-upload"};

module.exports = UploadInline;

UploadInline.default = UploadInline;
